/*
Author: Jude Fernando
Date: 25/09/2024
Copyright © 2024 Infix!. All rights reserved.
*/

import InputLabel from "@/components/Atoms/InputLabel";
import {RootState} from "@/reducers/store";
import {useValidate} from "@/state/survey/formSlice";
import {useEffect,useState} from "react";
import {useSelector} from "react-redux";

const MultipleChoiceInput = (props:any) => {
    const {node, children} = props;
    const form = useSelector((state:RootState) => state.form);
    const [selected, setSelected] = useState<string[]>([]);
    const validateInputField = useValidate()

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
         const { checked, value } = e.currentTarget;
        setSelected((prev: string[]) => {
            const valuelist  = checked ? [...prev, value] : prev.filter((val) => val !== value);
            validateInputField(node.name, valuelist, true)
            return valuelist
        }
           
        );
    };

    // "value": [
    //     {
    //       "type": "Pipe",
    //       "perDay":5,
    //       "years":10
    //     },
    //     {
    //       "type": "Cigarettes",
    //       "perDay":5,
    //       "years":10
    //     }
    //   ],

    useEffect(()=>{
        const formValue = form[node.name]?.value;

        if (Array.isArray(formValue)) {
            if (typeof formValue === 'string') {
                setSelected([formValue]); // Wrap the string in an array
            }
           
        } else {
            setSelected([]); // fallback to an empty array if the value is not a string array
        }
      
    },[form])

    return (
        <div className="p-5">
            <InputLabel>{node.title}</InputLabel>
            {
                node.options.map((field:string, i:number)=>(
                    <div key={i}><input checked={selected.some( (val:string) => val === field)}  type="checkbox" onChange={handleChange} value={field} name={node.name}/> <InputLabel>{field}</InputLabel></div>
                ))
            }          
            <div>{children}</div>
        </div>
    )
}

 export default MultipleChoiceInput;



/*
Author: Jude Fernando
Date: 25/09/2024
Copyright © 2024 Infix!. All rights reserved.
*/

// import InputLabel from "@/components/Atoms/InputLabel";
// import {useEffect} from "react";

// const MultipleChoiceInput = (props:any) => {
//     const {node, name, children, onChange, value} = props;

//     const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//         console.log(e.currentTarget.value)
//         onChange(name,e.target.value)
//     }
    
//     useEffect(()=>{
//         if (value){
//             onChange(name,value)
//         }
//     },[])

//     return (
//         <div className="p-5">
//             <InputLabel>{node.title}</InputLabel>
//             {
//                 node.options.map((o:string,i:number)=>(
//                     <div key={i}><input type="radio" checked={o==value} onChange={handleChange} value={o} name={name}/> <InputLabel>{o}</InputLabel></div>
//                 ))
//             }          
//             <div>{children}</div>
//         </div>
//     )
// }

// export default MultipleChoiceInput;